module.exports = __webpack_public_path__ + "static/media/xkang.78de2c96.png";